import {Globe} from 'lucide-react'
import {useLanguage} from '@/contexts/LanguageContext'

function Header() {
  const {language, toggleLanguage, t} = useLanguage()

  return (
    <header className="relative z-10 px-6 py-6">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="text-2xl font-bold bg-gradient-to-r from-indigo-400 via-sky-400 to-cyan-300 bg-clip-text text-transparent">
          NYGMA
        </div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={toggleLanguage}
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-gray-400 hover:text-white transition-colors px-3 py-2 rounded-md hover:bg-white/5"
          >
            <Globe className="w-4 h-4" />
            {language === 'ru' ? 'RU' : 'EN'}
          </button>
          <a
            href="https://t.me/slavique"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 font-medium border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white transition-all duration-300 rounded-md text-base h-12 px-6"
          >
            {t.header.contact}
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
